<ul class="accr-section">
	<li class="collapsable-section closed" *ngFor="let row of speed_maps_horses; let i = index">
		<table
			horse-panel-header
			class="table"
			[row]="row"
			[i]="[i]"
			[user]="user"
			(getRaceHorseDetailsIn)="getRaceHorseDetailsInner($event)"
		></table>
		<!-- table -->

		<div
			horse-details
			class="collapsed-content"
			[user]="user"
			[row]="row"
			[bb_count]="bb_count"
			(openBlackbookIn)="OpenBlackbook($event)"
		></div>
		<!-- collapsed-content -->
	</li>
	<!-- end collapsable-section -->
</ul>
